import {all} from 'redux-saga/effects'

import login from './login_saga';
import model from './model_saga';
import user from './user_saga';
import iframe from './iframe_saga';

export default function* root() {
    yield all([
        ...login.map(saga => saga()),
        ...model.map(saga => saga()),
        ...user.map(saga => saga()),
        ...iframe.map(saga => saga())
    ])
}